// Pure chat-log text helpers shared by PlayGround.vue and Stream.vue (SonarQube dedup).
// Bodies moved byte-identical from the components; each component keeps its existing
// method names (Replace_NewLine, _buildShortMemory / GetLogStream_BuildMemory) as
// one-line wrappers delegating here, so all call sites are unchanged.

export function replaceLeadingNewlines(input) {
  try {
    if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
      input = input.slice(1, input.length);
    }
    if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
      input = input.slice(1, input.length);
    }
  } catch {
  }
  return input;
}

export function buildShortMemoryText(DataLog_Data) {
  let Memory = null;
  try {
    let L_Memory = JSON.parse(DataLog_Data.shortmemory);
    if (L_Memory != null && L_Memory.length > 0) {
      Memory = "";
      for (let i = 0; i < L_Memory.length; i++) {
        Memory += "" + (i + 1) + ". " + L_Memory[i].role + " : " + L_Memory[i].content + "\n";
      }
    }
    else {
      Memory = DataLog_Data.shortmemory;
    }
  }
  catch {
    Memory = "";
  }
  return Memory;
}
